export default __webpack_public_path__ + "static/media/image5.68543881.png";